import { render, staticRenderFns } from "./AuditorioUnificado.vue?vue&type=template&id=5071f603"
import script from "./AuditorioUnificado.vue?vue&type=script&lang=js"
export * from "./AuditorioUnificado.vue?vue&type=script&lang=js"
import style0 from "./assets/auditorio.styl?vue&type=style&index=0&prod&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports